/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import backgroundImg from './global.png';

export const containerMarginCss = css({
  marginBottom: 55,
});

export const backgroundCircle = css({
  background: `url(${backgroundImg})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right',
  [MediaQueries.sm]: {
    backgroundSize: '182px',
    backgroundPosition: 'bottom right',
    width: '100%',
    paddingLeft: '20px',
    paddingRight: '20px',
  },
});

export const containerPaddingCss = css({
  [MediaQueries.sm]: { paddingBottom: '48px', paddingTop: '48px' },
});

export const browseresionContainer = css({
  padding: '0px 76px',
  [MediaQueries.sm]: { padding: '0px 0px' },

  '.textArea': {
    [MediaQueries.sm]: { paddingBottom: '32px', paddingTop: '0px' },
  },

  h2: {
    fontSize: '40px',
    lineHeight: '40px',
    letterSpacing: '-0.30000001192092896px',
    textAlign: 'left',
    fontWeight: 500,
    marginBottom: '32px',
    color: colorsPalette.black,
    [MediaQueries.sm]: {},
  },

  p: {
    fontSize: '22px',
    fontStyle: 'normal',

    lineHeight: '24px',
    letterSpacing: '-0.4000000059604645px',
    textAlign: 'left',
    color: colorsPalette.grey90,
  },

  '.ctabtn': {
    '.ctabutton': {
      maxWidth: '196px',
      borderRadius: '8px',
      [MediaQueries.sm]: { maxWidth: 'none' },
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [MediaQueries.sm]: { display: 'block', paddingBottom: '15px' },
  },
});
